module.exports = __webpack_public_path__ + "static/media/dark-theme-drop-arrow.2a19b599.svg";